module.exports = __webpack_public_path__ + "static/media/plane.d1b8f9c7.svg";